import React, { useState, useContext, useCallback, useEffect } from 'react';

import PresentPC from 'components/pages/AddJobDescription/PresentPC';
import PresentSP from 'components/pages/AddJobDescription/PresentSP';
import AppContext from 'fluxes/context';
import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';
import {
  UPDATE_ADD_JD,
  CHANGE_VALID,
} from 'fluxes/actions';

import {
  useWindowDimensions,
  useIECheck,
  sortErrors,
  useDirectTransCheck,
  isSchemaValid,
  MoveCheckStart,
  scrollTop,
  lockScroll,
  unLockScroll,
  groupByKey,
} from 'utils';

import {
  dutySkillApi,
} from 'utils/api';

import {
  CHOICES_MAP,
  CHOICES_NAME_MAP,
  COMMENT_MAP,
} from 'utils/constant';


const AddJobDescription = () => {
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);

  const [duty, setDuty] = useState(state.duty);
  const [dutyCmnt, setDutyCmnt] = useState(state.dutyCmnt);
  const [workInfoContent, setWorkInfoContent] = useState(state.workInfoContent);
  const [workInfoContentCmnt, setWorkInfoContentCmnt] = useState(state.workInfoContentCmnt);

  const [apiSkillList, setApiSkillList] = useState(state.apiSkillList);

  const [isOpenWorkInfoModal, setIsOpenWorkInfoModal] = useState(false);

  const [modalWorkInfoContent, setModalWorkInfoContent] = useState([]);
  const [modalWICShowList, setModalWICShowList] = useState([]);
  const [modalWICCurrent, setModalWICCurrent] = useState(0);
  const [modalWICCurrentCtNm, setModalWICCurrentCtNm] = useState('');
  const [modalWICIsLastBtn, setModalWICIsLastBtn] = useState(false);
  const [modalWICBtnValid, setModalWICBtnValid] = useState(true);

  // レスポンシブ
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  // 直接遷移チェック
  useDirectTransCheck({ state });
  MoveCheckStart();

  // 入力チェック用変数
  const initialValid = { valid: state.validMap[path], errorMessages: [] };
  const [valids, setValids] = useState({
    schema: initialValid,
  });

  // 初期入力チェック設定
  const [isShowError, setIsShowError] = useState({
    duty: false,
    dutyCmnt: false,
    workInfoContent: false,
    workInfoContentCmnt: false,
  });

  const [isApiError, setIsApiError] = useState(false);

  // エラーの画面表示で利用する値
  const valid = Object.keys(valids).every(key => valids[key].valid);

  const dispErrors = useCallback(() => {
    const { schema } = valids;
    const errors = sortErrors([
      ...schema.errorMessages,
    ]);
    const errorMap = errors.reduce((obj, error) => {
      const { target, message } = error;
      if (!isShowError[target] || Object.keys(obj).includes(target)) return obj;
      return { ...obj, [target]: message };
    }, {});
    return errorMap;
  }, [isShowError, valids]);

  // 入力チェック（全体）
  useEffect(() => {
    const [isValid, newErrorMessages] = isSchemaValid({
      target: {
        duty,
        dutyCmnt,
        workInfoContent,
        workInfoContentCmnt,
      },
    });
    // erros更新
    const newValid = { schema: { valid: isValid, errorMessages: newErrorMessages } };
    setValids(org => ({ ...org, ...newValid }));
  }, [
    duty,
    dutyCmnt,
    workInfoContent,
    workInfoContentCmnt,
    valid,
  ]);

  /**
   * 初期処理
   */
  const isDutyDisabled = (e) => {
    if (!!duty && duty.length >= 2) {
      return !duty.includes(e);
    } else {
      return false;
    }
  };

  const showWorkInfoContent = () => {
    let selectedSkill = [];
    if (!!workInfoContent && workInfoContent.length > 0) {
      apiSkillList.forEach(function (cat) {
        cat.skill.forEach(function (skill) {
          if (workInfoContent.includes(skill.skillCd)) {
            if (cat.categoryKindKbn === '1') {
              selectedSkill.push({
                category: '業務内容',
                skillCd: skill.skillCd,
                skillNm: skill.skillNm
              })
            } else {
              selectedSkill.push({
                category: cat.categoryNm,
                skillCd: skill.skillCd,
                skillNm: skill.skillNm
              })
            }
          }
        })
      });

      let printByCategory = [];
      printByCategory = groupByKey(selectedSkill, 'category');

      let temp = [];
      for (var key in printByCategory) {
        if (printByCategory.hasOwnProperty(key)) {
          let arr = printByCategory[key];
          let _temp = [];
          arr.forEach(function (item) {
            if (item) {
              _temp.push(item.skillNm);
            }
          })
          temp.push(
            <tr key={key}>
              <th>{key}</th>
              <td>{_temp.join(", ")}</td>
            </tr>
          )
        }
      }
      const returnMap = temp.map(item => {
        return (item)
      });
      return (
        <>
          <div className="workInfoDtl">
            <table className="">
              <tbody>
                {returnMap}
              </tbody>
            </table>
          </div>
        </>
      );
    }
  };

  // onChange
  const dutyOnChange = (e) => {
    const val = e.target.value;
    if (duty.includes(e.target.value)) {
      setDuty(duty.filter((item) => item !== val));
    } else {
      setDuty([...duty, val]);
    }
    if (val === COMMENT_MAP.dutyCmnt.value) {
      setDutyCmnt('');
    }
    setWorkInfoContent([])
  };

  const onChangeDutyCmnt = (e) => {
    setDutyCmnt(e.target.value);
    if (!isShowError.dutyCmnt) {
      setIsShowError({ ...isShowError, dutyCmnt: true });
    }
  };

  const onChangeWorkInfoContentCmnt = (e) => {
    setWorkInfoContentCmnt(e.target.value);
    if (!isShowError.workInfoContentCmnt) {
      setIsShowError({ ...isShowError, workInfoContentCmnt: true });
    }
  };

  // ボタン押下
  // state更新処理
  const updateState = () => {
    dispatch({
      type: UPDATE_ADD_JD,
      updAddJd: {
        duty,
        dutyCmnt,
        workInfoContent,
        workInfoContentCmnt,
        apiSkillList
      },
    });
  };

  const movePage = () => {
    scrollTop();
    updateState();
    dispatch({
      type: CHANGE_VALID,
      path,
      valid,
    });
  };

  const onClickMainButton = {
    prev: () => {
      movePage();
    },
    next: (e) => {
      movePage();
    },
  };

  /** * 業務内容 モーダル START *** */
  const changeWIC = () => {
    lockScroll();
    getSkillAPI();
  };
  const isCloseWorkInfoModal = () => {
    unLockScroll();
    setModalWICShowList([]);
    setModalWICCurrent(0);
    setIsOpenWorkInfoModal(false);
    setModalWICBtnValid(true);
  };

  const isSaveWorkInfoContent = () => {
    setWorkInfoContent(modalWorkInfoContent);
    isCloseWorkInfoModal(false);
  };

  const onChangeWorkInfoContent = (value) => {
    if (modalWorkInfoContent.includes(value)) {
      setModalWorkInfoContent(modalWorkInfoContent.filter((item) => item !== value));
    } else {
      setModalWorkInfoContent([...modalWorkInfoContent, value]);
    }
  };

  const onClickBackWorkInfoModal = () => {
    var temp = modalWICCurrent - 1;
    setModalWICCurrent(temp);
    mapSkill(temp, apiSkillList);
  };

  const onClickNextWorkInfoModal = () => {
    var temp = modalWICCurrent + 1;
    setModalWICCurrent(temp);

    if (Number(temp) < apiSkillList.length) {
      mapSkill(temp, apiSkillList);
    } else if (modalWorkInfoContent.length !== 0) {
      isSaveWorkInfoContent();
    }
  };

  useEffect(()=>{
    const isWorkInfoModalLastCat = () => {
      const isLastCat = modalWICCurrent === apiSkillList.length - 1;
      setModalWICIsLastBtn(isLastCat);
    }
    isWorkInfoModalLastCat();
  }, [modalWICCurrent, apiSkillList]);

  useEffect(()=>{
    const isValidWorkInfoModalBtn = () => {
      if(!modalWICIsLastBtn || modalWorkInfoContent.length > 0) {
        setModalWICBtnValid(true);
      } else {
        setModalWICBtnValid(false);
      }
    }
    isValidWorkInfoModalBtn();
  }, [modalWICIsLastBtn, modalWorkInfoContent]);

  const getSkillAPI = () => {
    const id = setTimeout(() => {
      dutySkillApi({ duty }).then((value) => {
        if (!!value) {
          setApiSkillList(value);
          const clone = [...workInfoContent];
          setModalWorkInfoContent(clone);
          setIsOpenWorkInfoModal(true);
          mapSkill(modalWICCurrent, value);
        } else {
          setIsApiError(true);
          return false;
        }
      }).catch(err => {
        setIsApiError(true);
        scrollTop();
        return false;
      });
    }, 200, duty);
    return id;
  };

  const mapSkill = (step, skillList) => {
    var temp = [];
    if (!!skillList && skillList.length > 0) {
      setModalWICCurrentCtNm(skillList[step].categoryNm);
      skillList[step].skill.map(skill => (
        temp.push(
          {
            value: skill.skillCd,
            label: skill.skillNm,
            id: 'skill' + skill.skillCd,
          }
        )
      ))
      setModalWICShowList(temp);
    }
  }

  const modalWICShowData = modalWICShowList.map((data) => ({
    id: data.id,
    value: data.value,
    onChange: () => onChangeWorkInfoContent(data.value),
    label: data.label,
    checked: modalWorkInfoContent.includes(data.value),
  }));

  // モーダル中身
  const contentWorkInfoModal = {
    title: modalWICCurrentCtNm,
    label: CHOICES_MAP.option,
    questionMark: false,
    type: 'BasicCheckBoxInput',
    list: modalWICShowData,
  };
  // モーダルボタン
  const btnLabel = modalWICIsLastBtn ? '完了' : '次へ進む（' + (modalWICCurrent + 1) + '/' + apiSkillList.length + '）'
  const buttonWorkInfoModal = {
    label: btnLabel,
    onClick: onClickNextWorkInfoModal,
    valid: modalWICBtnValid,
  };
  /** * 業務内容 モーダル END *** */

  // 画面項目
  const dutyTitle = () => {
    return <label>職種（選択できるのは<span className='note'>２つまで</span>です）</label>
  }
  const dutyDip = {
    title: dutyTitle(),
    subTitle: '複数ポジションで職種や業務内容が異なる場合は、お手数ですが別々にご依頼いただきますようお願いいたします。',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.dutyList.map((elem) => {
      const infoStr = 'duty';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: dutyOnChange,
        checked: duty.includes(elem.value),
        disabled: isDutyDisabled(elem.value),
      };
    }),
    type: 'BasicCheckBoxInput',
    comment: {
      title: COMMENT_MAP.dutyCmnt.title,
      visible: duty.includes(COMMENT_MAP.dutyCmnt.value),
      label: CHOICES_NAME_MAP.option,
      questionMark: false,
      popUpTitle: '',
      popUpDetail: '',
      relativePosArrow: '20%',
      name: 'dutyCmnt',
      textAreaValue: dutyCmnt,
      cmntOnChange: onChangeDutyCmnt,
      onInput: onChangeDutyCmnt,
      onCompositionEnd: onChangeDutyCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      errMessage: dispErrors().dutyCmnt,
      inValid: !!(dispErrors().dutyCmnt),
    },
  };

  const workInfoContentDip = {
    title: '業務内容',
    label: CHOICES_NAME_MAP.require,
    questionMark: true,
    popUpTitle: '',
    popUpDetail: '',
    subTitle: '',
    list: [
      <span key='workInfoDtlBtnArea'>
      <div className='workInfoDtlBtnArea'>
        <ClickOnlyButton
          label="業務内容を選択する"
          valid={duty.length !== 0}
          onClick={changeWIC}
        />
      </div>
      {!!workInfoContent ?
        <div className=''>
          {showWorkInfoContent()}
        </div>
        : <></>}
    </span>
    ],
    errorDispMessages: dispErrors().workInfoContent,
  };

  const workInfoContentModal = {
    modalIsOpen: isOpenWorkInfoModal,
    content: contentWorkInfoModal,
    button: buttonWorkInfoModal,
    onClickCloseButton: isCloseWorkInfoModal,
    onClickBackButton: onClickBackWorkInfoModal,
    max: apiSkillList.length,
    current: modalWICCurrent + 1,
    mdName: "業務内容を選択する",
    mdNote: "※全ページから1つ以上選択してください",
    style: 2,
  };

  const workInfoContentCmntDip = {
    title: COMMENT_MAP.workInfoContentCmnt.title,
    label: CHOICES_NAME_MAP.option,
    questionMark: false,
    popUpTitle: COMMENT_MAP.workInfoContentCmnt.popUpTitle,
    popUpDetail: COMMENT_MAP.workInfoContentCmnt.popUpDetail,
    subTitle: COMMENT_MAP.workInfoContentCmnt.subTitle,
    list: [{
      name: 'workInfoContentCmnt',
      value: workInfoContentCmnt,
      onChange: onChangeWorkInfoContentCmnt,
      onInput: onChangeWorkInfoContentCmnt,
      onCompositionEnd: onChangeWorkInfoContentCmnt,
      maxLength: '500',
      wordCount: '(500文字以下)',
      inValid: !!(dispErrors().workInfoContentCmnt),
    }],
    type: 'TextAreaInput',
    errMessage: dispErrors().workInfoContentCmnt,
  };

  return isSp ? (
    <PresentSP
      dutyDip={dutyDip}
      workInfoContentDip={workInfoContentDip}
      workInfoContentCmntDip={workInfoContentCmntDip}
      workInfoContentModal={workInfoContentModal}

      // onClick
      onClickMainButton={onClickMainButton}

      // valid
      valid={valid}
      isApiError={isApiError}
    />
  ) : (
    <PresentPC
      dutyDip={dutyDip}
      workInfoContentDip={workInfoContentDip}
      workInfoContentCmntDip={workInfoContentCmntDip}
      workInfoContentModal={workInfoContentModal}

      // onClick
      onClickMainButton={onClickMainButton}

      // valid
      valid={valid}
      isApiError={isApiError}
    />
  );
};

export default AddJobDescription;